import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles'; // Importações do ThemeProvider
import Planos from './pages/Planos';
import { store, persistor } from './store';
import Cadastro from './pages/Cadastro';
import Pagamento from './pages/Pagamento';
import Finalizar from './pages/Finalizar';
import NotFound from './pages/NotFound/notFound';
import { PersistGate } from 'redux-persist/integration/react';
import CheckoutPix from './pages/CheckoutPix/CheckoutPix';
import TrocarPlano from './pages/TrocarPlano';
import SelecionarPlano from './pages/SelecionarPlano';
import Contratar from './pages/Contratar';

// Configuração do tema Material-UI
const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  palette: {
    primary: {
      main: '#ff9f0d', // Cor personalizada para seu projeto
    },
    secondary: {
      main: '#f50057',
    },
  },
});

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ThemeProvider theme={theme}>
          <Router>
            <Routes>
              <Route path="assinar/:planoNome/:cupom?" element={<Planos />} />
              <Route path="trocarPlano/:planoNome/:planoID/:usuarioID/:xtoken" element={<TrocarPlano />} />
              <Route path="/cadastro" element={<Cadastro />} />
              <Route path="/pagamento" element={<Pagamento />} />
              <Route path="/finalizar" element={<Finalizar />} />
              <Route path="/checkoutpix" element={<CheckoutPix />} />
              <Route path="/*" element={<NotFound />} />
              <Route path="/:cupom?" element={<SelecionarPlano />} />
              <Route path="/contratar/:cupom?" element={<Contratar />} />
            </Routes>
          </Router>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
